import { Injectable } from '@angular/core';
import { GraphqlService } from '@shared/services/http/graphql.service';
import gql from 'graphql-tag';

@Injectable({ providedIn: 'root' })
export class SuggestionService {

  private createSuggestionMutation = gql`
  mutation ($data: SuggestionCreateInput!) {
    createSuggestion(data: $data) {
      id
    }
  }`;

  private updateSuggestionMutation = gql`
  mutation ($data: SuggestionUpdateInput!, $where: SuggestionWhereUniqueInput!) {
    updateSuggestion(data: $data, where: $where) {
      id
    }
  }`;

  constructor(
    private graphqlService: GraphqlService,
  ) { }

  createSuggestion(variables: { data: any }) {
    return this.graphqlService.mutate(this.createSuggestionMutation, variables);
  }

  updateSuggestion(variables: { data: any; where: any }) {
    return this.graphqlService.mutate(this.updateSuggestionMutation, variables);
  }


}
